import React from 'react'
import '../Styles/Cards.css'
import { IMAGES } from '../utils/images'
import { Link } from 'react-router-dom'



const Cards = ({heading,text_1,text_2,text_3,text_4,icon_1,icon_2,icon_3,icon_4,image,btnText}) => {

  return (
    <div className='card-container'>
        <div className='card-top'>
            <img src={image} className='card-top-img'/>
        </div>
        <div className='card-bottom-card'>
            <div className='card-bottom-title'>{heading}</div>

            <ul className='cards-ul'>
                <li id="cards-li"><img src={icon_1}/> {text_1}</li>
                <li id="cards-li"><img src={icon_2}/> {text_2} </li>
                <li id="cards-li"><img src={icon_3}/> {text_3}</li>
                <li id="cards-li"><img src={icon_4}/> {text_4}</li>

            </ul>
            <Link to='/enroll-now' className='link'>
            <button className='card-bottom-btn'>{btnText}</button>
            </Link>
        </div>
    </div>
  )
}

export default Cards